import React from 'react'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import styles from './Configuration.module.css'

import { connect } from 'react-redux'
import updateConfiguration from '../actions/configuration'
import { bindActionCreators } from 'redux'
import Crate from 'crate-core'

class Configuration extends React.Component {
  constructor(props) {
    super(props)
    let config = {
      id: '',
      pseudo: '',
      signalingServer: '',
      storageServer: '',
      stunTurn: ''
    }

    if (this.props.configuration) {
      config = { ...config, ...this.props.configuration }
    }
    this.state = config
  }

  render() {
    return (
      <div className="textContent">
        <h1>Configuration</h1>
        <form className={styles.container} noValidate autoComplete="off">
          <Card className={styles.card}>
            <CardContent>
              <Typography variant="h5" component="h2" gutterBottom>
                Identity
              </Typography>
              <Grid container spacing={12}>
                <Grid item xs={6}>
                  <TextField
                    disabled
                    id="id"
                    label="Identifier"
                    style={{ margin: 8 }}
                    placeholder="Random Identifier"
                    helperText="This is a random user Id"
                    fullWidth
                    value={this.state.id}
                    onChange={e => {
                      this.setState({ id: e.target.value })
                    }}
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <TextField
                    id="pseudo"
                    label="Pseudo Name"
                    style={{ margin: 8 }}
                    placeholder="Pseudo Name"
                    helperText="Enter please the your Pseudo Name *"
                    fullWidth
                    value={this.state.pseudo}
                    onChange={e => {
                      this.setState({ pseudo: e.target.value })
                    }}
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <div
                    className={styles.avatar}
                    dangerouslySetInnerHTML={{
                      __html: Crate.Marker.getAvatar(this.state.id)
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={styles.submit}>
              <Button
                variant="outlined"
                onClick={() => {
                  const id = Crate.getRandomId()
                  const pseudoName = Crate.Marker.getPseudoname(id)

                  this.setState({ pseudo: pseudoName })
                  this.setState({ id: id })
                }}
              >
                Generate New ID
              </Button>
            </CardActions>
          </Card>
          <Card className={styles.card}>
            <CardContent>
              <Typography variant="h5" component="h2" gutterBottom>
                Communication
              </Typography>

              <TextField
                id="signalingServer"
                label="Signaling Server"
                style={{ margin: 8 }}
                htmlFor="component-error"
                placeholder="Signaling server"
                helperText="Enter please the signaling server address for example: https://carteserver.herokuapp.com"
                fullWidth
                value={this.state.signalingServer}
                onChange={e => {
                  this.setState({ signalingServer: e.target.value })
                }}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
              />

              <TextField
                id="storageServer"
                label="Storage Server"
                style={{ margin: 8 }}
                placeholder="Storage server"
                helperText="Enter please the storage server address for example: https://storagecrate.herokuapp.com"
                fullWidth
                value={this.state.storageServer}
                onChange={e => {
                  this.setState({ storageServer: e.target.value })
                }}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
              />

              <TextField
                id="stun"
                label="STUN/TURN"
                style={{ margin: 8 }}
                placeholder="STUN/TURN address"
                helperText="Enter please the STUN or Turn server address for example:23.21.150.121"
                fullWidth
                value={this.state.stunTurn}
                onChange={e => {
                  this.setState({ stunTurn: e.target.value })
                }}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </CardContent>
            <CardActions />
          </Card>

          <div className={styles.submit}>
            <Button
              variant="outlined"
              onClick={() => {
                this.props.updateConfiguration({ ...this.state })
              }}
              className={styles.button}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return { configuration: state.configuration }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { updateConfiguration: updateConfiguration },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Configuration)
